<div [formGroup]="bookingEmailService.emailForm" *ngIf="bookingEmailService.emailForm">
    <p-dropdown placeholder="load a template" [options]="bookingEmailService.emailTemplates" optionLabel="name"
        formControlName="emailTemplate" (onChange)="bookingEmailService.insertEmailTemplate($event.value)"
        scrollHeight="600px" [style]="{'width':'400px'}" [filter]="true" filterBy="name"></p-dropdown>
    <div class="student-recipient-container" *ngIf="isEmailToStudent">
        Student address:
        <div *ngFor="let form of recipientsFormArray" [formGroup]="form | formGroup" class="student-recipient-item">
            <p-checkbox formControlName="isSelected" [binary]="true"></p-checkbox> <span>{{form.value.email}}: </span>
            <span>{{form.value.typeName}}</span>
        </div>
    </div>
    <div class="school-recipient-container" *ngIf="!isEmailToStudent">
        Send to:
        <div *ngFor="let form of recipientsFormArray" [formGroup]="form | formGroup" class="school-recipient-item">
            <p-checkbox formControlName="isSelected" [binary]="true"></p-checkbox> <span>{{form.value.email}}: </span>
            <span>{{form.value.typeName}}</span>
        </div>
    </div>
    <div>
        <div>
            <p>Subject: </p>
        </div>
        <div>
            <input formControlName="subject" pInputText class="subject-input-large">
        </div>
    </div>
    <ckeditor [editor]="Editor" formControlName="body"></ckeditor>
    <div>
        <span>
            Signature:
        </span>
        <p-dropdown placeholder="Signature" formControlName="signature"
            [options]="emailSignatureService.emailSignatures" optionLabel="language.name"></p-dropdown>
    </div>
    <div class="attatchment-template-edit-buttons-container">
        <div *ngIf="isEmailToStudent">
            <p-button label="Add attachment files"
                (onClick)="bookingEmailService.openStudentFileAttachmentDialog(bookingService.booking.id!)"></p-button>
        </div>
        <div *ngIf="!isEmailToStudent">
            <p-button label="Add attachment files"
                (onClick)="bookingEmailService.openSchoolFileAttachmentDialog(bookingService.booking.id!)"></p-button>
        </div>
        <div>
            <p-button label="Edit email template" (onClick)="openTemplateEditComponent()"
                [disabled]="!bookingEmailService.loadedTemplate"></p-button>
        </div>
    </div>

    <div *ngFor="let file of bookingEmailService.emailAttachmentFiles">
        <p>{{file.name}}</p>
        <p-button label="X" (onClick)="removeAttachment(file)"></p-button>
    </div>
</div>
<div class="send-button-container">
    <div class="send-button-wrap">
        <p-button label="Send" (onClick)="sendEmailToClient()"
            [disabled]="attachmentLoading || bookingEmailService.emailSending">
        </p-button>
    </div>
    <div class="cancel-button-wrap">
        <p-button label="Cancel" (onClick)="closeEmailDialog()" styleClass="p-button-warning"
            [disabled]="attachmentLoading || bookingEmailService.emailSending"></p-button>
    </div>
</div>
<div [formGroup]="bookingEmailService.emailForm">
    <p>Background Color</p>
    <p-dropdown placeholder="None" [options]="colors" appendTo="body" [showClear]="true"
        (onChange)="updateBackgroundColor($event.value)">
        <ng-template pTemplate="selectedItem">
            <div class="color-label-container" *ngIf="bookingEmailService.emailForm.value.backgroundColor">
                <div
                    [style]="{backgroundColor: bookingEmailService.emailForm.value.backgroundColor, width:'20px', height: '20px'}">
                </div>
                <span>
                    {{bookingEmailService.emailForm.value.backgroundColor}}
                </span>
            </div>
        </ng-template>
        <ng-template let-color pTemplate="item">
            <div class="color-label-container">
                <div [style]="{backgroundColor: color, width:'20px', height: '20px'}"></div>
                <span>
                    {{color}}
                </span>
            </div>
        </ng-template>
    </p-dropdown>
    <input pInputText formControlName="backgroundColor" class="background-color-input">
</div>
<div [formGroup]="bookingEmailService.emailForm" *ngIf="bookingEmailService.emailForm">
    <p-checkbox formControlName="withPastePixel" [binary]="true"></p-checkbox>
    <span>Use Paste Pixel</span>
</div>
<p-dialog header="Select Files to attach" [modal]="true" [(visible)]="bookingEmailService.displayFileAttachmentForm">
    <table class="file-import-table">
        <tr>
            <th>Name</th>
            <th>File type</th>
        </tr>
        <tr *ngFor="let form of bookingEmailService.fileAttachmentForm" [formGroup]="form">
            <td class="file-import-table-cell">
                <p-checkbox formControlName="isSelected" [binary]="true"
                    (onChange)="bookingEmailService.updateFilesToAttach(form)">
                </p-checkbox>
                <span>{{form.value.file.name}}</span>
            </td>
            <td class="file-import-table-cell">
                {{form.value.file.documentType?.name}}
            </td>
        </tr>
    </table>
    <p-button label="confirm" (onClick)="bookingEmailService.closeFileAttachmentDialog()"></p-button>
</p-dialog>